import { Box } from "@mui/material";
import { SingleMessageType } from "DataTypes/Chat.type";
import { FC } from "react";

export interface AudioComponentProps {
  message: SingleMessageType;
}

const AudioComponent: FC<AudioComponentProps> = (
  props: AudioComponentProps
) => {
  const { message } = props;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        backgroundColor: "#fff",
        padding: "8px 12px",
        borderRadius: "16px",
        border: "1px solid rgba(26, 35, 126, 0.15)",
        mt: 1,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      <audio
        controls
        style={{
          outline: "none",
          height: "32px",
          width: "210px",
        }}
      >
        <source src={message.attachmentUrl} type="audio/webm" />
        Your browser does not support the audio element.
      </audio>
    </Box>
  );
};

export default AudioComponent;
